import { useEffect, useState } from 'react';
import * as React from 'react';

import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import HomePage from './components/HomePage';
import InternalUserLogin from './components/Login/InternalUserLogin';
import PostGrievance from './components/Post_Grievance/PostGrievance';
import GrievanceSubmissionSummary from './components/Post_Grievance/GrievanceSubmissionSummary';
import Navbar from './components/Navbar';
import TrackGrievance from './components/Track_Grievance/TrackGrievance';
import Registration from './components/Registration/RegisterInternalUser';
import GrievanceDashboard from './components/Internal_User/GrievanceDashboard';
//import UserDashboard from './components/Internal_User/UserDashboard';
import GenerateReport from './components/Internal_User/GenerateReport';
import Protected from "./components/Protected";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SwipeableTemporaryDrawer from "./components/ThemeDrawer";
import DrawerComp from "./components/DrawerComp.js";
import ThemeDrawer from "./components/ThemeDrawer.js";


import ProtectedInternalUser from "./components/ProtectedInternalUser";

function App() {
    const [pages, setPages] = useState('')
    const selectedStyles = localStorage.getItem("Theme");
    console.log("style.." + selectedStyles);
    if (selectedStyles) {
        import(`./components/${selectedStyles}.css`);
    } else {
        import(`./App.css`)
    }

    useEffect(() => {
        asyncGetPages();
    }, []);


    const asyncGetPages = async () => {

        try {
            const strGetAllPages = 'home/getPages';
            await fetch(strGetAllPages, {
                method: 'POST'
            }).then(response => {
                return response.json()
            }).then(data => {
                console.log("data :: ", data);
                setPages(data);
            });
        } catch (error) {

            alert("Something went wrong : " + error)
            console.log("error : " + error);
        };
    }
    const [state, setState] = React.useState('right');

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    <Box
        sx={{ width: 250 }}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
    >
        <List>
            {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
                <ListItem key={text} disablePadding>
                    <ListItemButton>

                        <ListItemText primary={text} />
                    </ListItemButton>
                </ListItem>
            ))}
        </List>

    </Box>

    return (
        <div className="root" >

            <div className="App">

                <br />
                {/*<Navbar/>*/}
                <div className="wrapper">
                    <div className="content">
                        <br />

                        
                        <BrowserRouter>
                            <Routes>
                                <Route index element={<HomePage />} />

                            </Routes>
                            {pages && pages.map((data) => (

                                <Routes>
                                    {data.pageName === '/Post_Grievance' &&
                                        < Route path="/Post_Grievance" element={<Protected Component={PostGrievance} />} />
                                    }
                                    {data.pageName === '/Track_Grievance' &&

                                        <Route path="/Track_Grievance" element={< Protected Component={TrackGrievance} />} />
                                    }
                                    {data.pageName === '/InternalUserLogin' &&

                                        <Route path="/InternalUserLogin" element={<InternalUserLogin />} />
                                    }
                                    {data.pageName === '/GrievanceDashboard' &&

                                        <Route path="/GrievanceDashboard" element={<Protected Component={GrievanceDashboard} />} />
                                    }
                                    {/*{data.pageName === '/UserDashboard' &&*/}

                                    {/*    <Route path="/UserDashboard" element={<UserDashboard/>} />*/}
                                    {/*}*/}
                                    {data.pageName === '/GenerateReport' &&
                                        <Route path="/GenerateReport" element={<Protected Component={GenerateReport} />} />
                                    }
                                    {data.pageName == "/Login" &&

                                        <Route path="/Login" element={<Login />} />
                                    }
                                    {data.pageName == "/Register" &&

                                        <Route path="/Register" element={<Registration />} />
                                    }
                                    <Route path="/Navbar" element={<Navbar />} />
                                    {data.pageName == "/GrievanceSubmissionSummary" &&

                                        <Route path="/GrievanceSubmissionSummary" element={< Protected Component={GrievanceSubmissionSummary} />} />
                                    }
                                    {/*<Route path="/AlertDialog" element={<AlertDialog isOpen={this.} toggle={} title='' content=''  />} />*/}
                                    <Route path="/temp" element={<SwipeableTemporaryDrawer />} />
                                    <Route path="/DrawerComp" element={<DrawerComp />} />
                                    <Route path="/logout" element={<HomePage />} />

                                </Routes>
                            )
                            )}
                            </BrowserRouter>
                        

                    </div>

                </div>


            </div>
        </div>

    );
}

export default App;
